export default "__VITE_ASSET__06df6202__"